import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_address_book_hdr_RowClass} from '../../../dbschema/bl_crm_address_book_hdr.model'

export class CrmAddressBookHdrContainerModel extends BaseContainerModel {
    bl_crm_address_book_hdr: bl_crm_address_book_hdr_RowClass = new bl_crm_address_book_hdr_RowClass()
  }
